import { Show, onCleanup, createSignal } from "solid-js";
import { styled } from "styled-system/jsx";

const PANEL_SHOWN = "(min-width: 901px)";

const isMobileDevice = () =>
  /android|iphone|ipad|ipod/i.test(navigator.userAgent);

const Copy = styled("div", {
  base: {
    position: "relative",
    zIndex: 1,
    maxWidth: "min(100%, 400px)",
    marginTop: "clamp(28px, 5vh, 64px)",

    "& h2": {
      margin: 0,
      color: "#FFFFFF",
      fontSize: "clamp(1.9rem, 2.6vw, 2.7rem)",
      fontWeight: 700,
      letterSpacing: "-0.03em",
      lineHeight: 1.02,
    },

    "& h2 span": {
      color: "#C9A24B",
    },

    "& p": {
      maxWidth: "32ch",
      margin: "16px 0 0",
      color: "rgba(255, 255, 255, 0.72)",
      fontSize: "1rem",
      lineHeight: 1.6,
    },
  },
});

export function AppUpsell() {
  const panelQuery = window.matchMedia(PANEL_SHOWN);
  const [panelShown, setPanelShown] = createSignal(panelQuery.matches);

  const onChange = (event: MediaQueryListEvent) =>
    setPanelShown(event.matches);

  panelQuery.addEventListener("change", onChange);
  onCleanup(() => panelQuery.removeEventListener("change", onChange));

  return (
    <Show when={panelShown() && !isMobileDevice()}>
      <Copy>
        <h2>
          Welcome to <span>Majalis.</span>
        </h2>
        <p>
          Learn from educators. Grow in knowledge. Strengthen the Ummah for the
          sake of Allah.
        </p>
        <p>
          Join weekly seminars led by knowledgeable professionals and
          educators across a wide range of fields, including Islamic studies,
          medicine, marriage and family, fitness, business, marketing, and
          technology.
        </p>
        <p>
          Gain practical knowledge, ask questions, and learn directly from
          people with real-world experience.
        </p>
      </Copy>
    </Show>
  );
}
